import React from 'react';
import { useSelector } from 'react-redux';
import dateFormat from 'dateformat';
import {
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  IconButton,
  Chip,
  Paper,
  Tooltip
} from '@mui/material';
import {
  Add as AddIcon,
  Delete as DeleteIcon
} from '@mui/icons-material';
import ApiKeyUsageTooltip from '#component/user/settings/api-key/usage-tooltip';
import { formatApiKey, isExpired } from '#component/user/settings/api-key/util';
import {
  APIKeyCell,
  EmptyStateCell,
  EmptyStateIcon,
  ExpireContainer,
  Header,
  HeaderLeft,
  LabelCell,
  StyledContainer
} from './styles';
import { getDateTimeFormat } from '#helper';

const DesktopView = props => {
  const { apiKeys, setCreateDialogOpen, handleDeleteClick } = props;
  const measurementSystem = useSelector(state => state.account?.measurementSystem);
  const dateShortFormat = getDateTimeFormat(measurementSystem, 'dateShort');
  const dateTimeShortFormat = getDateTimeFormat(measurementSystem, 'dateTimeShort');

  return (
    <StyledContainer>
      <Header>
        <HeaderLeft>
          <Typography variant="h4" component="h1">
            API Keys
          </Typography>
          {apiKeys.length > 0 && <ApiKeyUsageTooltip />}
        </HeaderLeft>
        <Button
          color="secondary"
          variant="contained"
          startIcon={<AddIcon />}
          onClick={() => setCreateDialogOpen(true)}
        >
          Generate API Key
        </Button>
      </Header>

      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Label</TableCell>
              <TableCell>API Key</TableCell>
              <TableCell>Created</TableCell>
              <TableCell>Expires</TableCell>
              <TableCell align="right">Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {apiKeys.length === 0 ? (
              <TableRow>
                <EmptyStateCell colSpan={5} align="center">
                  <EmptyStateIcon />
                  <Typography variant="h6" color="text.secondary" gutterBottom>
                    No API keys found
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Generate your first API key to get started
                  </Typography>
                </EmptyStateCell>
              </TableRow>
            ) : (
              apiKeys.map(apiKey => (
                <TableRow key={apiKey.id}>
                  <LabelCell>
                    {apiKey.label ? (
                      <span title={apiKey.label}>{apiKey.label}</span>
                    ) : (
                      <Typography variant="body2" color="text.secondary" fontStyle="italic">
                        No label
                      </Typography>
                    )}
                  </LabelCell>
                  <APIKeyCell>
                    {formatApiKey(apiKey.startChar, apiKey.endChar)}
                  </APIKeyCell>
                  <TableCell>{dateFormat(apiKey.creationDate, dateShortFormat)}</TableCell>
                  <TableCell>
                    {apiKey.expirationDate ? (
                      <ExpireContainer>
                        <span>{dateFormat(apiKey.expirationDate, dateTimeShortFormat)}</span>
                        {isExpired(apiKey.expirationDate) && (
                          <Chip label="Expired" color="error" size="small" />
                        )}
                      </ExpireContainer>
                    ) : (
                      <Typography variant="body2" color="text.secondary">
                        Never
                      </Typography>
                    )}
                  </TableCell>
                  <TableCell align="right">
                    <Tooltip title="Delete API Key">
                      <IconButton
                        color="error"
                        onClick={() => handleDeleteClick(apiKey.id)}
                      >
                        <DeleteIcon />
                      </IconButton>
                    </Tooltip>
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </StyledContainer>
  );
};

export default DesktopView;
